import { useState, useEffect, createContext, useContext } from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import crm from "../crmApi";
import { Loader } from "../CrmApp";
import WmList from "./WmList";
import WmEditor from "./WmEditor";
import WmMedia from "./WmMedia";
import WmFeatured from "./WmFeatured";
import WmHistory from "./WmHistory";
import HeroApp from "./hero/HeroApp";

const PermCtx = createContext({});
export const useWmPerms = () => useContext(PermCtx);

export const inr = (n) => (!n ? "—" : n >= 10000000 ? `₹${(n / 10000000).toFixed(2)} Cr` : n >= 100000 ? `₹${(n / 100000).toFixed(1)} L` : `₹${Number(n).toLocaleString("en-IN")}`);
export const fileSrc = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const StatusBadge = ({ p }) => (
  <span className="inline-flex gap-1 flex-wrap">
    {p.is_published ? <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-green-100 text-green-700">Live{p.version ? ` v${p.version}` : ""}</span>
      : <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-pbs-grey/15 text-pbs-grey">{p.version ? "Unpublished" : "Never published"}</span>}
    {p.has_draft && <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-pbs-orange/15 text-pbs-orange">Draft changes</span>}
    {p.featured && <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-pbs-gold/20 text-pbs-plum">Featured</span>}
  </span>
);

const TABS = [["", "All Properties", "edit"], ["new", "Add Property", "edit"], ["edits", "Edit Listings", "edit"], ["media", "Media Library", "view"],
  ["featured", "Featured Properties", "edit"], ["status", "Drafts & Published", "edit"], ["history", "Change History", "edit"], ["hero", "Hero Campaigns", "view"]];

export default function WebsiteApp() {
  const [perms, setPerms] = useState(null);
  useEffect(() => { crm.wm.perms().then(setPerms).catch(() => setPerms({ can_view: true })); }, []);
  if (!perms) return <Loader />;
  const tabs = TABS.filter(([, , need]) => need === "view" || perms.can_edit);
  return (
    <PermCtx.Provider value={perms}>
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <h1 className="text-xl font-bold text-pbs-dark tracking-tight">Website Management</h1>
        <span className="crm-badge tone-grey" data-testid="wm-perm-note">{perms.can_publish ? "You can publish to the live website" : perms.can_edit ? "You can edit drafts · publishing needs Owner approval" : "View approved listings & share with leads"}</span>
      </div>
      <div className="flex gap-1 overflow-x-auto no-scrollbar mb-5 border-b border-pbs-line">
        {tabs.map(([path, label]) => (
          <NavLink key={label} to={`/crm/website${path ? `/${path}` : ""}`} end={path !== "hero"} data-testid={`wm-tab-${path || "all"}`}
            className={({ isActive }) => `px-3 h-10 flex items-center text-[13px] font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${isActive ? "border-pbs-purple text-pbs-purple" : "border-transparent text-pbs-grey hover:text-pbs-dark"}`}>{label}</NavLink>
        ))}
      </div>
      <Routes>
        <Route index element={perms.can_edit ? <WmList /> : <WmMedia />} />
        <Route path="new" element={<WmEditor />} />
        <Route path="edit/:id" element={<WmEditor />} />
        <Route path="edits" element={<WmList preset="drafts" />} />
        <Route path="status" element={<WmList tabs />} />
        <Route path="media" element={<WmMedia />} />
        <Route path="featured" element={<WmFeatured />} />
        <Route path="history" element={<WmHistory />} />
        <Route path="hero/*" element={<HeroApp />} />
      </Routes>
    </PermCtx.Provider>
  );
}
